<template>
  <header id="open" class="header">
    <div id="close" class="header__container">
      <div class="header__menu menu">
        <div class="menu__info menu-info">
          <div class="menu__social">
            <a href="https://ok.ru/group/62395649097921" target="_blank">
              <img src="../assets/svg/odnoklassniki.svg" alt="Одноклассники">
            </a>
            <a href="t.me/dar_altay_russia" target="_blank">
              <img src="../assets/svg/telegram.svg" alt="Телеграм">
            </a>
            <a href="https://vk.com/dar_altay_russia" target="_blank">
              <img src="../assets/svg/vk-dark.svg" alt="ВКонтакте">
            </a>
            <a href="https://max.ru/dar_altay_russia" target="_blank">
              <img src="../assets/svg/MAX.svg" alt="МАКС">
            </a>
          </div>

          <div class="menu-info__index-info header-info">
            <div class="header-info__svg">
              <img src="../assets/svg/location.svg" alt="Локация" class="header-info__img">
            </div>
            <div class="header-info__wrap-text">
              <p class="text-circe-18 color-green">Алтайский край</p>
              <p class="text-circe-14 color-gray">г.Барнаул, ул. Фомина, 154</p>
            </div>
          </div>
          <router-link to="/" class="header__logo">
            <img src="../assets/svg/logo.svg" alt="Логотип" />
          </router-link>
          <div class="menu-info__index-info header-info">
            <div class="header-info__svg">
              <img src="../assets/svg/phone.svg" alt="Телефон" class="header-info__img-2">
            </div>
            <div class="header-info__wrap-text">
              <a href="tel:591130" class="text-circe-18 color-green">591-130</a>
              <p class="text-circe-14 color-gray">Телефоны горячей линии</p>
            </div>
          </div>
          <button
            ref="searchIconMobile"
            type="button"
            class="header__search-toggle"
            aria-label="Поиск по сайту"
            @click="toggleSearch"
          >
            <img src="../assets/svg/search.svg" alt="" width="22" height="22">
          </button>
          <div ref="burgerButton" class="burger-menu" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="menu-info__btn">
            <a href="https://medangel.xn--22-6kcp5d.xn--p1ai" target="_blank">
              <button class="login-btn" >
                <img src="../assets/svg/profile.svg" alt="Профиль">
                Личный кабинет
              </button>
            </a>
          </div>
        </div>
        <div class="menu__wrap">
          <nav ref="burgerMenuBody" class="menu__body" :class="{ 'menu__body--open': isOpen }">
            <a
              href="https://medangel.xn--22-6kcp5d.xn--p1ai"
              target="_blank"
              class="menu__body-login"
              @click="closeMenu"
            >
              <img src="../assets/svg/profile.svg" alt="Профиль">
              Личный кабинет
            </a>
            <ul class="menu__list">
              <menu-item
                  v-for="(item, index) in menuItems"
                  :key="index"
                  :item="item"
                  :is-root="true"
                  :is-menu-open="isOpen"
                  @close="closeMenu"
              />
            </ul>
            <button
              ref="searchMenuBtn"
              type="button"
              class="menu__body-search text-TTDrugs-regular-16 text-uppercase"
              @click="openSearchFromMenu"
            >
              Поиск
            </button>
          </nav>
          <div class="menu-contact__button">
            <div
              ref="searchIcon"
              class="menu-contact__button-svg-search"
              @click="toggleSearch"
            >
              <img src="../assets/svg/search.svg" alt="Поиск">
            </div>
            <div class="menu-contact__button-svg-eye">
              <img id="specialButton" style="cursor:pointer;" src="https://lidrekon.ru/images/special.png" alt="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ" title="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ" />
            </div>
          </div>
        </div>
        <AppSearch v-if="showSearch" @close-search="closeSearch" :showSearch="showSearch" ref="searchArea"/>
      </div>
    </div>
  </header>
</template>

<script>
import AppSearch from '@/components/Search/Search.vue'
import MenuItem from "@/components/Menu/MenuItem.vue";
import { mapState } from 'vuex'; // Используем mapState и mapActions
import { actionTypes } from "@/store/modules/menuItems";

export default {
  name: "AppHeader",
  components: { AppSearch, MenuItem},
  data() {
    return {
      showSearch: false,
      isOpen: false,
    };
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch;
      if (this.showSearch) {
        this.closeMenu();
      }
    },
    openSearchFromMenu() {
      this.showSearch = true;
      this.closeMenu();
    },
    closeSearch() {
      this.showSearch = false;
    },
    handleClickOutside(event) {
      const target = event.target;

      const burgerMenuBody = this.$refs.burgerMenuBody;
      const burgerButton = this.$refs.burgerButton;
      if (
        this.isOpen &&
        burgerMenuBody &&
        !burgerMenuBody.contains(target) &&
        (!burgerButton || !burgerButton.contains(target))
      ) {
        this.closeMenu();
      }

      if (!this.showSearch) {
        return;
      }
      const searchArea = this.$refs.searchArea?.$el;
      const searchIcon = this.$refs.searchIcon;
      const searchIconMobile = this.$refs.searchIconMobile;
      const searchMenuBtn = this.$refs.searchMenuBtn;

      if (!searchArea) {
        return;
      }
      if (
        searchArea.contains(target) ||
        (searchIcon && searchIcon.contains(target)) ||
        (searchIconMobile && searchIconMobile.contains(target)) ||
        (searchMenuBtn && searchMenuBtn.contains(target))
      ) {
        return;
      }

      this.closeSearch();
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    routerGo() {
      if (this.$route.path !== '/appeal') {
        this.$router.push('/appeal');
      }
    },
    // Добавляем метод для загрузки меню
    loadMenuItems() {
      this.$store.dispatch(`menuItems/${actionTypes.loadMenuItems}`);
    }
  },
  computed: {
    // Используем mapState для получения данных из store
    ...mapState('menuItems', {
      menuItems: state => state.menuItems,
      isLoading: state => state.isLoading,
      error: state => state.error
    })
  },
  watch: {
    $route() {
      this.closeSearch();
      this.closeMenu();
    }
  },
  mounted() {
    // Загружаем меню при монтировании компонента
    this.loadMenuItems();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>